import GoingUtils from "@/utils/goingUtils";
import {StorageUtils} from "xmgoing-utils";
import {Modal} from "ant-design-vue";
import {loadOutSystem} from "@/utils/xmCom/loadSystem";
import axios from "axios";
import {ref} from "vue";

export function useLoginSwitchHook({token}){

  const visibility = useDocumentVisibility()
  const { resume } = useTimeoutPoll(checkUpdate, 2 * 60 * 10 ** 3)
  const lastBuildTime = ref('')
  /** 后台已发现、尚未在前台处理完的服务器构建 */
  let pendingNewBuildTime = ''
  let versionModal: { destroy: () => void } | null = null
  let accountModal: { destroy: () => void } | null = null

  function isForegroundVisible () {
    return unref(visibility) === 'visible'
  }

  function hasAccountChanged () {
    const newSessionToken = StorageUtils.getSessionItem('sessionId');
    const newLocalToken = StorageUtils.getItem('access_token')?.replaceAll('"', '');
    return !!(token && (token !== newSessionToken || token !== newLocalToken || newLocalToken !== newSessionToken));
  }

  function blurActiveElement () {
    const el = document.activeElement as HTMLElement | null
    if (el && typeof el.blur === 'function') {
      el.blur()
    }
  }

  function dismissVersionModal () {
    if (!versionModal) {
      return
    }
    versionModal.destroy()
    versionModal = null
    blurActiveElement()
  }

  function showVersionPrompt (buildTime: string) {
    if (versionModal || accountModal) {
      return
    }
    if (!isForegroundVisible() || hasAccountChanged()) {
      pendingNewBuildTime = buildTime
      return
    }
    pendingNewBuildTime = buildTime
    versionModal = Modal.confirm({
      title: '发现新版本',
      content: '立即重新加载？',
      okText: '确定',
      cancelText: '取消',
      zIndex: 9999,
      autoFocusButton: null,
      focusTriggerAfterClose: false,
      onOk: () => {
        location.reload()
      },
      onCancel: () => {
        lastBuildTime.value = buildTime
        pendingNewBuildTime = ''
        versionModal = null
      }
    })
  }

  /**
   * 校验是否发布了最新版本
   */
  async function checkUpdate () {
    const url = new URL('/buildInfo.json', location.origin).toString()
    try {
      const { data: { buildTime } } = await axios.get<{buildTime: string}>(url, {
        params: { _t: Date.now() },
        headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
      })
      if (!unref(lastBuildTime)) {
        lastBuildTime.value = buildTime
        return
      }
      if (unref(lastBuildTime) === buildTime) {
        pendingNewBuildTime = ''
        dismissVersionModal()
        return
      }
      if (!isForegroundVisible() || accountModal || hasAccountChanged()) {
        pendingNewBuildTime = buildTime
        dismissVersionModal()
        return
      }
      showVersionPrompt(buildTime)
    } catch (e) {
      console.log('checkUpdate', e)
    }
  }

  const watchAccountChange = !GoingUtils.isAppShowFlag() && !GoingUtils.operateLoginFlag()

  watch(visibility, (state) => {
    if (state === 'hidden') {
      dismissVersionModal()
      return
    }
    if (state !== 'visible') {
      return
    }
    setTimeout(()=>{
      if (!isForegroundVisible()) {
        return
      }
      if (watchAccountChange && window.sessionStorage.getItem("analysisSetFlag") !== 'analysisSetFlag') {
        if (hasAccountChanged()) {
          dismissVersionModal()
          if (!accountModal) {
            accountModal = Modal.error({
              title: '当前登录账号发生了变化，请重新登录。',
              keyboard: false,
              maskClosable: false,
              okText: '重新登录',
              onOk: () => {
                loadOutSystem();
              }
            })
          }
          return
        }
      }
      if (pendingNewBuildTime && pendingNewBuildTime !== unref(lastBuildTime)) {
        showVersionPrompt(pendingNewBuildTime)
      }
      if (process.env.NODE_ENV === 'production') {
        void checkUpdate()
      }
    },300)
  })

  if (process.env.NODE_ENV === 'production') {
    resume()
  }

  return {

  }

}
